import * as t from 'io-ts';

export const ApiUsageExportCodec = t.type({
    content: t.string,
});
export type ApiUsageExport = t.TypeOf<typeof ApiUsageExportCodec>;
